export enum RoleCategory {
  GUEST, USER, ADMIN
}

export enum RoleFunction {
  ROLE_GUEST = 'ROLE_GUEST',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_PUBLISHING = 'ROLE_PUBLISHING',
  ROLE_ACCEPTING = 'ROLE_ACCEPTING',
  ROLE_PARTICIPANT = 'ROLE_PARTICIPANT',
  ROLE_SCIENTIFIC = 'ROLE_SCIENTIFIC'
}